import { render, staticRenderFns } from "./Industry.vue?vue&type=template&id=456f41ab&scoped=true"
import script from "./Industry.vue?vue&type=script&lang=js"
export * from "./Industry.vue?vue&type=script&lang=js"
import style0 from "./Industry.vue?vue&type=style&index=0&id=456f41ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f41ab",
  null
  
)

export default component.exports